import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFlag: 0,
  emailApproachList: [],
  emailPageDetails: {},
  emailFormData: {
    emailApproach: "",
    emailServer: "",
    commonEmail: "",
    password: "",
    displayName: "",
    dnsText: ""
  },
  validationErrors: {},
  errorMessage: null,
  successMessage: null,
};

export const emailSettings = createSlice({
  name: "emailSettings",
  initialState,
  reducers: {
    // Email Form data handle
    updateFileld: (state, action) => {
      const { field, value } = action.payload;
      state.emailFormData[field] = value;
    },
    // Email approach dropdown list
    setEmailApproachDropdownLists: (state, action) => {
      state.emailApproachList = action.payload;
    },
    // Email page details
    setEmailPageDetails: (state, action) => {
      state.emailFormData = action.payload;
    },
    // Common Success message
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    // Commom Error Message
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    // Common Loading increment flag
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    // Common Loading decrement flag
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
  },
});

export const {
  setEmailApproachDropdownLists,
  setEmailPageDetails,
  setSuccessMessage,
  setErrorMessage,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  updateFileld
} = emailSettings.actions;
export default emailSettings.reducer;
